import React, { useEffect, useRef, useState } from "react";
import { VideoSuiteAppInterface } from "../../../../Types/VideoSuite-Types";
import { Box, Typography } from "@mui/material";
import { InputText } from "../../../ImageSuite/Components/Shared/InputText";
import { AppActionButton } from "../../../ImageSuite/Components/Shared/AppActionButton";
import OutputVideo from "../Shared/OutputVideo";
import VideoAppSettings from "../Shared/VideoAppSettings";
import SignalRService from "../../../one-query/services/SignalRService";
import {
  useAddSoundEffect,
  useGenerateVideoGeneratorApp,
} from "../../../../store/Apis/SuitesApps/VideoSuiteApi";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  appContainerStyle,
  appInputOutputContainerStyle,
} from "../../../ImageSuite/Components/Shared/styles";
import { AddSoundEffectButton } from "../Shared/AddSoundEffectButton";
import { setSnackBarAlert } from "../../../../store/one-query/chatsSlice";

const VideoGeneratorApp = ({
  videoSettings,
  activeAppProps,
  generatedPrompt,
  setInputValue,
  handleSetIsLoading,
  toggleLockSeed,
  handleModelSettingChanges,
  IsGeneratePromptLoading,
  handelGenerateRandomPrompt,
  getErrorMessage,
  isVideoPromptImproving,
  handelImprovePrompt,
  handleVideoWithSoundEffect,
  soundEffectData,
  setSoundEffectParams,
  isSoundEffectsLoading
}: VideoSuiteAppInterface) => {
  const dispatch = useAppDispatch();
  const outputVideoRef = useRef<HTMLVideoElement | null>(null)
  const appSuiteCosts=useAppSelector((s)=>s.User.AppSuiteCosts)
  const [showMoreSettings, setShowMoreSettings] = useState<boolean>(false);
  const [showSoundEffectModal,setShowSoundEffectModal] = useState<boolean>(false);
  const {
    mutate: GenerateVideoGeneratorApp,
    isPending: isPendingImageToVideoGenerating,
    error,
  } = useGenerateVideoGeneratorApp();
  const [isSoundEffect, setIsSoundEffect] = useState<boolean>(false);
  const {
    mutate: AddSoundEffectRequest,
    isPending: isPendingSoundEffectAdding,
    data: newVideoUrlWithSoundEffect,
  } = useAddSoundEffect();

  useEffect(() => {
    if (isPendingImageToVideoGenerating || isPendingSoundEffectAdding) {
      handleSetIsLoading(true);
    }
  }, [isPendingImageToVideoGenerating, isPendingSoundEffectAdding]);
  useEffect(() => {
    if (error) {
      getErrorMessage(error);
    }
  }, [error]);
  useEffect(() => {
    if (newVideoUrlWithSoundEffect) {
      handleSetIsLoading(false);
      if (handleVideoWithSoundEffect) {
        handleVideoWithSoundEffect(newVideoUrlWithSoundEffect);
      }
      setIsSoundEffect(true);
    }
  }, [newVideoUrlWithSoundEffect]);
  
  const handleGenerationAction = async () => {
    setIsSoundEffect(false);
     const connectionId = await SignalRService.getInstance().getConnectionId();
       const videoGeneratorRequest={
        connectionId:connectionId,
        prompt:activeAppProps?.inputValue,
        ratio:activeAppProps?.settings.selectedSize||"",
        duration:activeAppProps?.settings.selectedDuration ||"",
        style:activeAppProps?.settings.selectedStyle.value ||"",
        resolution:activeAppProps?.settings.selectedMode ||"",
        model:activeAppProps?.settings.selectedModel.name||"",
        version:activeAppProps?.settings.selectedModel.version||""

        // seed:!activeAppProps?.openLockSeed? activeAppProps?.settings.seed:null,
       }
       GenerateVideoGeneratorApp(videoGeneratorRequest)
  };
  const handleAddSoundEffectAction = async (soundEffectId: string) => {
    const videoElement = outputVideoRef.current;
    
    if (videoElement === null) {
      dispatch(
        setSnackBarAlert({
          show: true,
          message: "Oops! The video’s sound effects aren’t working right now because of a file issue. We're on it—thanks for bearing with us!",
          alertType: "error",
        })
      );
    } else {
      const duration = videoElement.duration.toString();
      const videoGeneratorWithSoundRequest = {
        videoUrl: activeAppProps?.outputUrl,
        duration: duration,
        soundEffectId: soundEffectId,
      };
      AddSoundEffectRequest(videoGeneratorWithSoundRequest);
      if (handleVideoWithSoundEffect) {
        handleVideoWithSoundEffect("");
      }
      setShowSoundEffectModal(false);
    }
  };

  return (
    <Box sx={appContainerStyle}>
      <Box className="image-suites-input-header">
        <Typography className="image-suites-input-header-title">
          Bring your text-based imagination into intuitive visuals
        </Typography>
      </Box>
      <Box sx={appInputOutputContainerStyle}>
        <Box className="image-suites-input">
          <Box className="image-suites-input-failed">
            <Box className="image-suites-input-failed zero-padding">
              <Typography className="settings-title">Prompt</Typography>
              <InputText
                example={activeAppProps?.example}
                setInputValue={setInputValue}
                inputValue={activeAppProps?.inputValue}
                handelGenerateRandomPrompt={handelGenerateRandomPrompt}
                IsGeneratePromptLoading={IsGeneratePromptLoading}
                isGenerateImgLoading={activeAppProps?.isLoading}
                generatedPrompt={generatedPrompt}
                isImprovePromptDisabled={isVideoPromptImproving}
                handelImprovePrompt={handelImprovePrompt}
              />
              <VideoAppSettings
                selectedVideoSettings={{
                  selectedSize: activeAppProps?.settings.selectedSize || "",
                  selectedModel: activeAppProps?.settings.selectedModel
                    ? {
                        name: activeAppProps.settings.selectedModel.name,
                        version: activeAppProps.settings.selectedModel.version,
                      }
                    : { name: "", version: "" },
                  selectedMode: activeAppProps?.settings.selectedMode || "",
                  selectedDuration:
                    activeAppProps?.settings.selectedDuration || "",
                  selectedStyle: activeAppProps?.settings.selectedStyle,
                  seed: activeAppProps?.settings.seed,
                }}
                openLockSeed={activeAppProps?.openLockSeed}
                toggleLockSeed={toggleLockSeed}
                handleModelSettingChanges={handleModelSettingChanges}
                showMoreSettings={showMoreSettings}
                setShowMoreSettings={setShowMoreSettings}
                videoAppSettings={videoSettings}
              />
            </Box>
          </Box>
          <AppActionButton
            creditsCount={
              activeAppProps?.settings?.creditsNeeded ?? appSuiteCosts?.Video
            }
            appMethodFire={handleGenerationAction}
            isGenerateButtonDisabled={activeAppProps?.isLoading}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            inputValue={activeAppProps?.inputValue}
          />
        </Box>
        <Box className="image-suites-output">
          <Box className="image-suites-output-result">
            <Box
              sx={{
                width: "100%",
                height: "90%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography className="image-suites-output-result-placeholder">
                  {activeAppProps?.isLoading || activeAppProps?.outputUrl
                    ? "Output"
                    : "Sample Output"}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <OutputVideo
                  ref={outputVideoRef}
                  videoUrl={
                    activeAppProps?.outputUrl
                      ? activeAppProps?.outputUrl
                      : activeAppProps?.example.result
                  }
                  isLoading={activeAppProps?.isLoading}
                  generateTime={activeAppProps?.settings.generateTime}
                />
              </Box>
              {activeAppProps?.outputUrl &&
                !activeAppProps.isLoading &&
                !isSoundEffect && (
                  <AddSoundEffectButton
                    showSoundEffectModal={showSoundEffectModal}
                    setShowSoundEffectModal={setShowSoundEffectModal}
                    setSoundEffectParams={setSoundEffectParams}
                    handleAddSoundEffectAction={handleAddSoundEffectAction}
                    soundEffectData={soundEffectData}
                    isLoading={isSoundEffectsLoading}
                  />
                )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VideoGeneratorApp;
